import DangerousIcon from '@mui/icons-material/Dangerous'
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material'
import { AxiosError } from 'axios'

interface ErrorDialogProps {
    data: any
    open: boolean
    onClose: () => void
}

export const formatError = (error: unknown) => {
    if (error instanceof AxiosError) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return Object.keys(error.response?.data).length ? error.response!.data : error.message
    }
    return `${error}`
}

const ErrorDialog = ({ data, open, onClose }: ErrorDialogProps) => {
    return (
        <Dialog open={data ? open : false}>
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <DangerousIcon sx={{ marginRight: 1 }} color="error" />
                    <Typography variant="h6">Error</Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography variant="overline">{JSON.stringify(data, null, 4)}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ErrorDialog
